import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ExpertisePage from "@/pages/ExpertisePage";
import ServicesPage from "@/pages/ServicesPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import CaseStudyDetailPage from "@/pages/CaseStudyDetailPage";
import IndustryDetailPage from "@/pages/IndustryDetailPage";
import FintechPage from "@/pages/FintechPage";
import EdtechPage from "@/pages/EdtechPage";
import ConstructionPage from "@/pages/ConstructionPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsOfUsePage from "@/pages/TermsOfUsePage";
import HumanRightsPage from "@/pages/HumanRightsPage";
import ModernSlaveryPage from "@/pages/ModernSlaveryPage";
import OHAndSPolicyPage from "@/pages/OHAndSPolicyPage";
import PrivacyCookiesPage from "@/pages/PrivacyCookiesPage";
import NotFoundPage from "@/pages/NotFoundPage";
import SeoLandingPage from "@/pages/SeoLandingPage";


// Admin Imports
import LoginPage from "@/pages/admin/LoginPage";
import DashboardPage from "@/pages/admin/DashboardPage";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import AnalyticsTracker from "./analytics/AnalyticsTracker";

// ScrollToTop component to fix the scroll issue
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Layout Wrapper to conditionally show/hide Navbar and Footer
function MainLayout() {
  const location = useLocation();
  const isAdminPath = location.pathname.startsWith("/admin");

  return (
    <div className="App min-h-screen bg-white">
      {!isAdminPath && <Navbar />}
      <main>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/expertise" element={<ExpertisePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/ai-services" element={<SeoLandingPage key="ai-services" slug="ai-services" />} />
          <Route path="/ai-implementation" element={<SeoLandingPage key="ai-implementation" slug="ai-implementation" />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/case-studies/:id" element={<CaseStudyDetailPage />} />
          <Route path="/industries/fintech" element={<FintechPage />} />
          <Route path="/industries/edtech" element={<EdtechPage />} />
          <Route path="/industries/construction" element={<ConstructionPage />} />
          <Route path="/industries/:id" element={<IndustryDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-use" element={<TermsOfUsePage />} />
          <Route path="/human-rights" element={<HumanRightsPage />} />
          <Route path="/modern-slavery" element={<ModernSlaveryPage />} />
          <Route path="/ohs-policy" element={<OHAndSPolicyPage />} />
          <Route path="/privacy-cookies" element={<PrivacyCookiesPage />} />

          {/* Admin Routes */}
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/admin/dashboard" element={<DashboardPage />} />
          </Route>

          {/* Catch-all Route for 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      {!isAdminPath && <Footer />}
      <Toaster position="top-right" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <ScrollToTop />
      <MainLayout />
    </BrowserRouter>
  );
}

export default App;
